
import { useState, useEffect } from 'react';
import HeroGallery from './components/HeroGallery';
import Bio from './components/Bio';
import SocialProof from './components/SocialProof';
import TrendingProjects from './components/TrendingProjects';
import Newsletter from './components/Newsletter';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4 flex items-center justify-between">
          <a href="#" className="text-lg md:text-xl font-medium tracking-wide text-stone-900 cursor-pointer">
            Sarah Creates
          </a>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <a href="#portfolio" className="text-sm text-stone-600 hover:text-stone-900 transition-colors cursor-pointer">Portfolio</a>
            <a href="#about" className="text-sm text-stone-600 hover:text-stone-900 transition-colors cursor-pointer">Services</a>
            <a href="#contact" className="text-sm text-stone-600 hover:text-stone-900 transition-colors cursor-pointer">Pricing</a>
            <a 
              href="#contact" 
              className="bg-stone-900 text-white px-5 py-2.5 rounded-full text-sm font-medium hover:bg-stone-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              Work With Me
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-stone-900 cursor-pointer"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <i className="ri-close-line text-2xl"></i>
            ) : (
              <i className="ri-menu-line text-2xl"></i>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-stone-200 shadow-lg">
            <div className="px-4 py-4 space-y-3">
              <a 
                href="#portfolio" 
                onClick={() => setMobileMenuOpen(false)}
                className="block text-base text-stone-600 hover:text-stone-900 transition-colors cursor-pointer py-2"
              >
                Portfolio
              </a>
              <a 
                href="#about" 
                onClick={() => setMobileMenuOpen(false)}
                className="block text-base text-stone-600 hover:text-stone-900 transition-colors cursor-pointer py-2"
              >
                Services
              </a>
              <a 
                href="#contact" 
                onClick={() => setMobileMenuOpen(false)}
                className="block text-base text-stone-600 hover:text-stone-900 transition-colors cursor-pointer py-2"
              >
                Pricing
              </a>
              <a 
                href="#contact" 
                onClick={() => setMobileMenuOpen(false)}
                className="block w-full bg-stone-900 text-white px-5 py-3 rounded-full text-base font-medium hover:bg-stone-800 transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                Work With Me
              </a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <HeroGallery />

      {/* About & Services */}
      <Bio />

      {/* Portfolio */}
      <TrendingProjects />

      {/* Testimonials */}
      <SocialProof />

      {/* Pricing */}
      <ContactCTA />

      {/* FAQ */}
      <Newsletter />

      {/* Footer */}
      <Footer />
    </div>
  );
}
